import { api, tr } from './shared';

export function getGettingStartedSections(lang) {
  return [
    {
      id: 'getting-started',
      category: tr(lang, 'С чего начать', 'Getting started'),
      navOrder: 0,
      navLabel: tr(lang, 'С чего начать', 'Getting started'),
      title: tr(lang, 'С чего начать', 'Getting started'),
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Этот раздел — единая точка входа для интеграции с Loyal Club. Пройдите шаги ниже по порядку: от доступа и прав до первого успешного сценария начисления/списания.',
            'This section is the single entry point for Loyal Club integration. Follow the steps below in order: from access and permissions to the first successful accrual/write-off flow.',
          ),
        },
        {
          type: 'list',
          title: tr(lang, 'Базовые адреса среды', 'Environment base URLs'),
          items: [
            tr(lang, `UI (приложение): ${api.appHost}`, `UI (app): ${api.appHost}`),
            tr(lang, `Public API: ${api.publicV1}`, `Public API: ${api.publicV1}`),
            tr(lang, `MoySklad Loyalty API: ${api.moyskladLoyalty}`, `MoySklad Loyalty API: ${api.moyskladLoyalty}`),
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'Рекомендуемый порядок интеграции', 'Recommended integration sequence'),
          items: [
            tr(lang, '1) Раздел «Авторизация» — выберите модель доступа: Bearer токен пользователя или X-Api-Key организации', '1) "Authentication" section — choose access model: user Bearer token or organization X-Api-Key'),
            tr(lang, '2) Раздел «API ключи — обзор» и «Управление» — создайте ключ, назначьте scopes по принципу минимальных прав', '2) "API keys — overview" and "Management" sections — create key and assign scopes by least privilege'),
            tr(lang, '3) Раздел Public API v1 → «Обзор», «Scopes», «Rate limit», «Идемпотентность» — зафиксируйте операционный контракт интеграции', '3) Public API v1 → "Overview", "Scopes", "Rate limit", "Idempotency" — align on operational integration contract'),
            tr(lang, '4) Раздел Public API v1 → «Пошаговый сценарий интеграции» — пройдите onboarding end-to-end на тестовых данных', '4) Public API v1 → "Step-by-step integration playbook" — run end-to-end onboarding with test data'),
            tr(lang, '5) Если используете r_keeper — раздел «Интеграции → R-Keeper»: org-level, API-ключ, restaurant code, FarCards, test-card', '5) If you use r_keeper — "Integrations → R-Keeper": org-level, API key, restaurant code, FarCards, test-card'),
            tr(lang, '6) Если используете iiko — раздел «Интеграции → iiko»: org-level ключ, customer/info, order/calc|apply|cancel', '6) If you use iiko — "Integrations → iiko": org-level key, customer/info, order/calc|apply|cancel'),
            tr(lang, '7) Если используете YClients — webhook + Marketplace/Plugin iframe в разделе «Интеграции → YClients»', '7) If you use YClients — webhook + Marketplace/Plugin iframe under "Integrations → YClients"'),
            tr(lang, '8) Если используете МойСклад — раздел «Интеграции → МойСклад (Loyalty API)» (предпочитайте /integration/organization/{org_id})', '8) If using MoySklad — "Integrations → MoySklad (Loyalty API)" (prefer /integration/organization/{org_id})'),
            tr(lang, '9) amoCRM connector — «Интеграции → amoCRM» на app.loyalclub.ru', '9) amoCRM connector — "Integrations → amoCRM" on app.loyalclub.ru'),
            tr(lang, '10) Онлайн-запись — «Онлайн-запись» (/public/booking), Wallet и short links — разделы Wallet', '10) Online booking — "Online booking" (/public/booking); Wallet and short links — Wallet sections'),
            tr(lang, '11) Перед go-live — проверьте обработку ошибок 401/403/404/409/422/429, retry/backoff и ротацию ключей', '11) Before go-live — verify handling of 401/403/404/409/422/429, retry/backoff, and key rotation'),
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'Что где находится в документации', 'Where to find what in docs'),
          items: [
            tr(lang, '«Авторизация» — заголовки доступа и базовые правила использования токенов/ключей', '"Authentication" — access headers and baseline token/key usage rules'),
            tr(lang, '«API ключи — обзор/управление» — создание, ротация, отключение ключей и права (scopes)', '"API keys — overview/management" — key create/rotate/revoke and scopes'),
            tr(lang, 'Public API v1 → «Обзор/Модель данных/Типы событий» — предметная модель и бизнес-логика операций', 'Public API v1 → "Overview/Data model/Event types" — domain model and business operation logic'),
            tr(lang, 'Public API v1 → endpoint-разделы (cards/clients/client-cards/transactions) — контракты запросов/ответов и примеры', 'Public API v1 → endpoint sections (cards/clients/client-cards/transactions) — request/response contracts and examples'),
            tr(lang, 'Public API v1 → «Формат ошибок», «Операционные правила», «Идемпотентность», «Go-live checklist» — production-правила интеграции', 'Public API v1 → "Error format", "Operational rules", "Idempotency", "Go-live checklist" — production integration rules'),
            tr(lang, '«Интеграции → R-Keeper» — org-level, FarCards XML/JSON, health/test-card', '"Integrations → R-Keeper" — org-level, FarCards XML/JSON, health/test-card'),
            tr(lang, '«Интеграции → iiko» — кассовый calc/apply/cancel по X-API-Key', '"Integrations → iiko" — POS calc/apply/cancel via X-API-Key'),
            tr(lang, '«Интеграции → YClients» — org-level webhook, Marketplace install/callback, plugin iframe', '"Integrations → YClients" — org-level webhook, Marketplace install/callback, plugin iframe'),
            tr(lang, '«Интеграции → МойСклад (Loyalty API)» — org-level token + Loyalty API кассы', '"Integrations → MoySklad (Loyalty API)" — org-level token + POS Loyalty API'),
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'Минимальный функциональный сценарий (обязательно пройти)', 'Minimal functional scenario (must pass)'),
          items: [
            tr(lang, 'Проверка доступа: GET /api/v1/organization', 'Access check: GET /api/v1/organization'),
            tr(lang, 'Поиск/создание клиента: GET /api/v1/clients или POST /api/v1/clients', 'Find/create client: GET /api/v1/clients or POST /api/v1/clients'),
            tr(lang, 'Выпуск карты: POST /api/v1/client-cards/issue', 'Issue card: POST /api/v1/client-cards/issue'),
            tr(lang, 'Начисление/списание: POST /api/v1/transactions (рекомендуется с Idempotency-Key)', 'Accrual/write-off: POST /api/v1/transactions (recommended with Idempotency-Key)'),
            tr(lang, 'Проверка результата: GET /api/v1/client-cards и GET /api/v1/transactions', 'Verify result: GET /api/v1/client-cards and GET /api/v1/transactions'),
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'Ответственная эксплуатация в production', 'Responsible production operation'),
          items: [
            tr(lang, 'Используйте только HTTPS и серверное хранение секретов', 'Use HTTPS only and server-side secret storage'),
            tr(lang, 'Ограничивайте scopes по задаче интеграции, не выдавайте лишние права', 'Limit scopes to integration tasks, avoid excessive permissions'),
            tr(lang, 'Используйте retry с backoff и соблюдайте Retry-After при 429', 'Use retry with backoff and honor Retry-After on 429'),
            tr(lang, 'Для транзакций включайте Idempotency-Key, чтобы избежать дублей при сетевых сбоях', 'Use Idempotency-Key for transactions to avoid duplicates during network failures'),
            tr(lang, 'Настройте ротацию ключей и revoke-процедуру для инцидентов', 'Set up key rotation and revoke procedure for incidents'),
          ],
        },
      ],
    },
    {
      id: 'auth',
      category: tr(lang, 'С чего начать', 'Getting started'),
      navOrder: 10,
      navLabel: tr(lang, 'Авторизация', 'Authentication'),
      title: tr(lang, 'Авторизация', 'Authentication'),
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Для основной интеграции с Loyal Club используйте Bearer-токен пользователя или API ключ организации.',
            'For the main Loyal Club integration use a user Bearer token or an organization API key.',
          ),
        },
        {
          type: 'list',
          title: tr(lang, 'Заголовки', 'Headers'),
          items: [
            'Authorization: Bearer <USER_TOKEN>',
            'X-Api-Key: <API_KEY>',
          ],
        },
        {
          type: 'text',
          value: tr(
            lang,
            'API ключ организации можно создать в интерфейсе: Профиль → Персональные настройки → API ключи. Ключ показывается полностью только один раз (при создании/ротации), далее отображается маска.',
            'You can create an organization API key in the UI: Profile → Personal settings → API keys. The key is shown in full only once (on create/rotate), then it is masked.',
          ),
        },
      ],
    },
    {
      id: 'api-keys-overview',
      category: tr(lang, 'С чего начать', 'Getting started'),
      navGroup: tr(lang, 'API ключи', 'API keys'),
      navGroupOrder: 20,
      navOrder: 0,
      navLabel: tr(lang, 'Обзор', 'Overview'),
      title: tr(lang, 'API ключи — обзор', 'API keys — overview'),
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'API ключ организации предназначен для серверных интеграций (Public API v1). Ключ привязан к одной организации и даёт доступ только к её данным.',
            'An organization API key is intended for server-to-server integrations (Public API v1). The key is bound to a single organization and can access only its data.',
          ),
        },
        {
          type: 'list',
          title: tr(lang, 'Как получить', 'How to get'),
          items: [
            tr(lang, 'Откройте: Профиль → Персональные настройки → API ключи', 'Open: Profile → Personal settings → API keys'),
            tr(lang, 'Нажмите "Создать API ключ"', 'Click "Create API key"'),
            tr(lang, 'Скопируйте ключ — он показывается полностью только один раз', 'Copy the key — it is shown in full only once'),
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'Заголовки', 'Headers'),
          items: ['X-Api-Key: <API_KEY>'],
        },
        {
          type: 'text',
          value: tr(
            lang,
            'Управление API ключами (создание/ротация/отключение) доступно только через Bearer-токен пользователя (владельца/менеджера).',
            'API key management (create/rotate/revoke) is available only via a user Bearer token (owner/manager).',
          ),
        },
      ],
    },
    {
      id: 'api-keys-list',
      category: tr(lang, 'С чего начать', 'Getting started'),
      navGroup: tr(lang, 'API ключи', 'API keys'),
      navGroupOrder: 20,
      navSubgroup: tr(lang, 'Управление', 'Management'),
      navSubgroupOrder: 10,
      navOrder: 10,
      navLabel: tr(lang, 'Список ключей', 'List keys'),
      title: 'GET /api-keys',
      blocks: [
        { type: 'text', value: tr(lang, 'Вернёт список ключей в маскированном виде.', 'Returns API keys in masked form.') },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Authorization: Bearer <USER_TOKEN>'] },
        { type: 'list', title: tr(lang, 'Коды ответов', 'Response codes'), items: [tr(lang, '200 — успешно', '200 — success'), tr(lang, '401 — не авторизован', '401 — unauthorized'), tr(lang, '403 — нет доступа', '403 — forbidden')] },
        {
          type: 'code',
          title: 'curl',
          key: 'api-keys-list',
          value: `curl -X GET "${api.host}/api-keys" \\\n  -H "Authorization: Bearer <USER_TOKEN>"`,
        },
      ],
    },
    {
      id: 'api-keys-create',
      category: tr(lang, 'С чего начать', 'Getting started'),
      navGroup: tr(lang, 'API ключи', 'API keys'),
      navGroupOrder: 20,
      navSubgroup: tr(lang, 'Управление', 'Management'),
      navSubgroupOrder: 10,
      navOrder: 20,
      navLabel: tr(lang, 'Создать ключ', 'Create key'),
      title: 'POST /api-keys',
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Создаёт новый API ключ. Полное значение ключа возвращается только в этом ответе.',
            'Creates a new API key. The full key is returned only in this response.',
          ),
        },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Authorization: Bearer <USER_TOKEN>'] },
        { type: 'list', title: tr(lang, 'Коды ответов', 'Response codes'), items: [tr(lang, '200 — успешно', '200 — success'), tr(lang, '401 — не авторизован', '401 — unauthorized'), tr(lang, '403 — нет доступа', '403 — forbidden')] },
        {
          type: 'code',
          title: tr(lang, 'Тело запроса', 'Request body'),
          key: 'api-keys-create-body',
          value: `{\n  "name": "1C prod",\n  "scopes": ["organization:read","cards:read","clients:read","client_cards:read","transactions:read"]\n}`,
        },
        {
          type: 'code',
          title: 'curl',
          key: 'api-keys-create',
          value: `curl -X POST "${api.host}/api-keys" \\\n  -H "Content-Type: application/json" \\\n  -H "Authorization: Bearer <USER_TOKEN>" \\\n  -d '{\n    "name": "1C prod",\n    "scopes": ["organization:read","cards:read","clients:read","client_cards:read","transactions:read"]\n  }'`,
        },
      ],
    },
    {
      id: 'api-keys-rotate',
      category: tr(lang, 'С чего начать', 'Getting started'),
      navGroup: tr(lang, 'API ключи', 'API keys'),
      navGroupOrder: 20,
      navSubgroup: tr(lang, 'Управление', 'Management'),
      navSubgroupOrder: 10,
      navOrder: 30,
      navLabel: tr(lang, 'Ротация ключа', 'Rotate key'),
      title: 'POST /api-keys/{id}/rotate',
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Перевыпускает секрет ключа. Полное значение ключа возвращается только в этом ответе.',
            'Reissues the key secret. The full key is returned only in this response.',
          ),
        },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Authorization: Bearer <USER_TOKEN>'] },
        { type: 'list', title: tr(lang, 'Параметры пути', 'Path params'), items: ['id (int)'] },
        { type: 'list', title: tr(lang, 'Коды ответов', 'Response codes'), items: [tr(lang, '200 — успешно', '200 — success'), tr(lang, '401 — не авторизован', '401 — unauthorized'), tr(lang, '403 — нет доступа', '403 — forbidden'), tr(lang, '404 — не найдено', '404 — not found'), tr(lang, '409 — конфликт состояния', '409 — conflict')] },
        {
          type: 'code',
          title: 'curl',
          key: 'api-keys-rotate',
          value: `curl -X POST "${api.host}/api-keys/<API_KEY_ID>/rotate" \\\n  -H "Authorization: Bearer <USER_TOKEN>"`,
        },
      ],
    },
    {
      id: 'api-keys-revoke',
      category: tr(lang, 'С чего начать', 'Getting started'),
      navGroup: tr(lang, 'API ключи', 'API keys'),
      navGroupOrder: 20,
      navSubgroup: tr(lang, 'Управление', 'Management'),
      navSubgroupOrder: 10,
      navOrder: 40,
      navLabel: tr(lang, 'Отключить ключ', 'Revoke key'),
      title: 'POST /api-keys/{id}/revoke',
      blocks: [
        { type: 'text', value: tr(lang, 'Отключает ключ. Использование ключа станет невозможным.', 'Revokes the key. It can no longer be used.') },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Authorization: Bearer <USER_TOKEN>'] },
        { type: 'list', title: tr(lang, 'Параметры пути', 'Path params'), items: ['id (int)'] },
        { type: 'list', title: tr(lang, 'Коды ответов', 'Response codes'), items: [tr(lang, '200 — успешно', '200 — success'), tr(lang, '401 — не авторизован', '401 — unauthorized'), tr(lang, '403 — нет доступа', '403 — forbidden'), tr(lang, '404 — не найдено', '404 — not found')] },
        {
          type: 'code',
          title: 'curl',
          key: 'api-keys-revoke',
          value: `curl -X POST "${api.host}/api-keys/<API_KEY_ID>/revoke" \\\n  -H "Authorization: Bearer <USER_TOKEN>"`,
        },
      ],
    },
  ];
}
